import {
  FASTTRACK_SCRIPT_URL
} from '../config';

export const loadFasttrackScript = (onloadCallback: () => void): void => {
  const script = document.createElement('script');
  script.async = false;
  script.src = FASTTRACK_SCRIPT_URL;
  script.onload = () => { onloadCallback?.();; }
  document.body.appendChild(script);
};